import React, { useRef } from "react"
import { Box, Container, Heading, Flex } from "@theme-ui/components"
import ArticleThumb from "../components/articleThumb"
import { GiHorizontalFlip } from "react-icons/gi"
import { i18nContext } from "../context/i18nContext"

// Begin swiper
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/pagination"
import { Pagination } from "swiper/modules"
import { InboundLink } from "./link"
import { getBlogPath } from "../utils/path"
// End swiper

const LatestArticles = ({ articles }) => {
  const customContainerRef = useRef()

  return (
    <Box
      sx={{
        ".swiper": {
          pb: [6],
        },
        ".swiper-wrapper": { alignItems: "stretch" },
        pt: [4, 9],
        pb: [4, 6],
      }}
    >
      <i18nContext.Consumer>
        {t => (
          <Container
            className="customcontainer"
            ref={customContainerRef}
            sx={{ py: [0, 0] }}
          >
            <Flex
              sx={{
                mb: [3, 4, 7],
                alignItems: "baseline",
                justifyContent: "space-between",
              }}
            >
              <Heading
                as="h2"
                variant="h1"
                sx={{
                  mb: [0],
                  fontWeight: "400",
                }}
              >
                {t.latestArticles}
              </Heading>
              <InboundLink to={getBlogPath(t.locale)}>
                {t.readMoreNews}
              </InboundLink>
            </Flex>
          </Container>
        )}
      </i18nContext.Consumer>
      <Container>
        <Swiper
          autoHeight
          slidesPerView={3}
          slidesPerGroup={3}
          modules={[Pagination]}
          pagination={{
            clickable: true,
          }}
          breakpoints={{
            320: {
              spaceBetween: "16px",
              slidesPerView: 1,
              slidesPerGroup: 1,
            },
            640: {
              spaceBetween: "32px",
              slidesPerView: 3,
              slidesPerGroup: 3,
            },
          }}
        >
          {articles.map(article => (
            <SwiperSlide key={article.id}>
              <ArticleThumb theme="light" article={article} small />
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
      <Container
        className="customcontainer"
        ref={customContainerRef}
        sx={{
          py: [0, 0],
          display: "flex",
          alignItems: "center",
          color: "primary",
          svg: {
            fill: "primary",
          },
        }}
      >
        Drag to move{" "}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            ml: [2],
          }}
        >
          <GiHorizontalFlip />
        </Box>
      </Container>
    </Box>
  )
}

export default LatestArticles
